import { render, staticRenderFns } from "./ProjectProfile.vue?vue&type=template&id=06d61412"
import script from "./ProjectProfile.vue?vue&type=script&lang=js"
export * from "./ProjectProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports